import Alert from 'garden/src/js/components/alert'

export default function alert (textMessage, ...options) {
  return new Alert(Object.assign({}, { textMessage }, ...options))
}
